import React from "react";
import { Star } from "lucide-react";
import "./styles/BusinessRatingPill.css";

interface BusinessRatingPillProps {
  avgRating: number;
  totalRatings: number;
}

function ratingColorClass(avgRating: number): string {
  if (avgRating >= 4.5) return "biz-rating-stars--green";
  if (avgRating >= 4.0) return "biz-rating-stars--light-green";
  if (avgRating >= 3.0) return "biz-rating-stars--yellow";
  if (avgRating >= 2.0) return "biz-rating-stars--orange";
  return "biz-rating-stars--red";
}

/** Nine-labelled star + average score pill next to the business name —
 *  no review count. Color signals the rating band: 4.5-5 green, 4-4.4 light green, 3-3.9 yellow, 2-2.9 orange, <2 red. */
const BusinessRatingPill: React.FC<BusinessRatingPillProps> = ({ avgRating, totalRatings }) => {
  if (totalRatings === 0) return null;
  const colorClass = ratingColorClass(avgRating);
  return (
    <span
      className={`biz-rating-stars ${colorClass}`}
      aria-label={`Nine community rating ${avgRating.toFixed(1)} out of 5 from ${totalRatings} ${totalRatings === 1 ? "rating" : "ratings"}`}
      title="Rated by the Nine community"
    >
      <span className="biz-rating-stars__source">Nine</span>
      <span className="biz-rating-stars__score">
        <Star size={14} strokeWidth={2.5} fill="currentColor" aria-hidden="true" />
        <strong>{avgRating.toFixed(1)}</strong>
      </span>
    </span>
  );
};

export default BusinessRatingPill;
